{
  "friendsScreen": {
    "tabs": {
      "suggestions": "Suggestions",
      "search": "Recherche",
      "requests": "Demandes"
    },
    "common": {
      "loading": "Chargement…"
    },
    "suggestions": {
      "sectionTitle": "Personnes que vous pourriez connaître",
      "empty": "Aucune suggestion pour l'instant",
      "endOfList": "— Fin des suggestions —"
    },
    "search": {
      "placeholder": "Rechercher par nom ou prénom…",
      "sectionTitle": "Résultats de la recherche",
      "noResults": "Aucun résultat pour « {{query}} »",
      "hint": "Trouvez de nouvelles personnes"
    },
    "requests": {
      "receivedTab": "Reçues ({{count}})",
      "sentTab": "Envoyées ({{count}})",
      "receivedSubtitle": "Souhaite se connecter avec vous",
      "sentSubtitle": "Vous avez envoyé une demande",
      "emptyReceived": "Aucune nouvelle demande",
      "emptySent": "Aucune demande en attente",
      "accept": "Accepter",
      "decline": "Refuser",
      "cancel": "Annuler"
    }
  },
  "messagesScreen": {
    "defaultUserName": "Moi",
    "loadingData": "Chargement des données",
    "you": "Vous :",
    "tabs": {
      "history": "Historique",
      "online": "En ligne",
      "friends": "Amis",
      "groups": "Groupes"
    },
    "search": {
      "placeholderHistory": "Rechercher une conversation",
      "placeholderOnline": "Rechercher un ami en ligne",
      "placeholderFriends": "Rechercher un ami",
      "placeholderGroups": "Rechercher un groupe"
    },
    "status": {
      "online": "En ligne",
      "offline": "Hors ligne"
    },
    "preview": {
      "noMessage": "Aucun message",
      "photo": "📷 Photo",
      "video": "🎬 Vidéo",
      "audio": "🎵 Audio",
      "file": "📁 Fichier"
    },
    "time": {
      "now": "À l'instant",
      "minutes_one": "{{count}}min",
      "minutes_other": "{{count}}min",
      "hours_one": "{{count}}h",
      "hours_other": "{{count}}h",
      "days_one": "{{count}}j",
      "days_other": "{{count}}j"
    },
    "empty": {
      "noResultsTitle": "Aucun résultat",
      "noConversationsFor": "Aucune conversation pour « {{query}} »",
      "noMessagesTitle": "Vous n'avez aucun message",
      "noMessagesSubtitle": "Démarrez la discussion avec vos amis",
      "noOnlineFriendsFor": "Aucun ami en ligne pour « {{query}} »",
      "noOnlineFriendsTitle": "Aucun ami en ligne",
      "noFriendsFor": "Aucun ami pour « {{query}} »",
      "noFriendsTitle": "Aucun ami"
    },
    "sync": {
      "titleInProgress": "Synchronisation en cours",
      "titleDone": "Données actualisées",
      "titleError": "Synchronisation échouée",
      "done": "Synchronisation réussie",
      "genericError": "Une erreur est survenue.",
      "steps": {
        "checking": "Initialisation…",
        "refreshing": "Actualisation…",
        "syncing": "Synchronisation des données…",
        "syncingData": "Synchronisation des données"
      },
      "errors": {
        "pleaseReconnectData": "Veuillez vous reconnecter pour accéder à vos données.",
        "pleaseReconnect": "Veuillez vous reconnecter.",
        "cannotRefresh": "Impossible d'actualiser les données. Veuillez vous reconnecter.",
        "userNotFound": "Identifiant utilisateur introuvable. Veuillez vous reconnecter.",
        "syncFailed": "Une erreur est survenue lors de la synchronisation. Vérifiez votre connexion et réessayez."
      }
    }
  },
  "profileScreen": {
    "loading": "Chargement...",
    "retry": "Réessayer",
    "memberSince": "Membre depuis {{date}}",
    "errors": {
      "cannotLoadProfile": "Impossible de charger le profil"
    },
    "roles": {
      "supreme": "⚡ Supreme",
      "adminPro": "👑 Admin PRO",
      "admin": "🛡 Administrateur",
      "pro": "⭐ Utilisateur PRO"
    },
    "stats": {
      "cfa": "CFA",
      "trophies": "Trophées"
    },
    "account": {
      "sectionLabel": "MON COMPTE",
      "topUp": {
        "title": "Recharger mon solde",
        "sub": "Rapide · Sécurisé · Mobile Money"
      },
      "settings": {
        "title": "Paramètres",
        "sub": "Nom, prénom, date de naissance"
      },
      "privacy": {
        "title": "Confidentialité",
        "sub": "Vie privée, données & sécurité"
      },
      "guide": {
        "title": "Guide d'utilisation",
        "sub": "Tout savoir sur Harmonia"
      }
    },
    "info": {
      "sectionLabel": "INFORMATIONS",
      "lastName": "Nom",
      "firstName": "Prénom",
      "birthDate": "Date de naissance"
    },
    "posts": {
      "title": "Publications ({{count}})",
      "publishButton": "Publier",
      "emptyTitle": "Aucune publication",
      "emptySub": "Partagez votre première publication !"
    },
    "post": {
      "tapToPlay": "Appuyer pour lire",
      "commentsCount_one": "{{count}} commentaire",
      "commentsCount_other": "{{count}} commentaires",
      "sharesCount_one": "{{count}} partage",
      "sharesCount_other": "{{count}} partages"
    },
    "postDetails": {
      "title": "📊 Détails",
      "author": "Auteur :",
      "published": "Publié :",
      "reactions": "Réactions :",
      "close": "Fermer"
    },
    "avatar": {
      "updated": "Photo de profil mise à jour !",
      "errors": {
        "accessRequired": "Accès aux photos requis.",
        "cannotUpdate": "Impossible de mettre à jour la photo"
      }
    },
    "createPost": {
      "title": "Nouvelle publication",
      "placeholder": "Quoi de neuf ?",
      "photo": "Photo",
      "video": "Vidéo",
      "videoReady": "Vidéo prête",
      "publish": "Publier",
      "published": "Post publié !",
      "imageAdded": "Image ajoutée !",
      "videoAdded": "Vidéo ajoutée !",
      "visibility": {
        "public": "Public",
        "friends": "Amis",
        "pro": "PRO",
        "private": "Privé"
      },
      "errors": {
        "contentRequired": "Le contenu est obligatoire",
        "limitReached": "Limite de publications atteinte.",
        "cannotPublish": "Impossible de publier",
        "mediaAccessRequired": "Accès aux médias requis.",
        "cannotAddMedia": "Impossible d'ajouter le média"
      }
    },
    "settings": {
      "header": {
        "title": "Paramètres",
        "subtitle": "Modifier vos informations personnelles"
      },
      "updated": "Profil mis à jour !",
      "fields": {
        "lastName": "Nom",
        "lastNamePlaceholder": "Votre nom",
        "firstName": "Prénom",
        "firstNamePlaceholder": "Votre prénom",
        "birthDate": "Date de naissance"
      },
      "language": {
        "label": "Langue",
        "intro": "Choisissez la langue dans laquelle vous souhaitez utiliser Harmonia. Le changement s'applique immédiatement à toute l'application.",
        "options": {
          "fr": { "name": "Français", "native": "French" },
          "en": { "name": "Anglais", "native": "English" },
          "es": { "name": "Espagnol", "native": "Español" },
          "pt": { "name": "Portugais", "native": "Português" }
        }
      },
      "actions": {
        "cancel": "Annuler",
        "save": "Enregistrer"
      },
      "errors": {
        "nameRequired": "Nom et prénom obligatoires",
        "cannotSave": "Impossible de sauvegarder",
        "cannotChangeLanguage": "Impossible de changer de langue"
      }
    }
  },
  "vueProfilModal": {
    "loading": "Chargement...",
    "memberSince": "Membre depuis {{date}}",
    "premiumBadge": "Premium",
    "actions": {
      "sendInvite": "Envoyer invitation",
      "cancelRequest": "Annuler demande",
      "accept": "Accepter",
      "decline": "Refuser",
      "removeFriend": "Retirer ami"
    },
    "errors": {
      "cannotLoadProfile": "Impossible de charger le profil"
    }
  },
  "chatBox": {
    "retry": "Réessayer",
    "loadingData": "Chargement des données",
    "loadingEllipsis": "Chargement…",
    "loadPreviousMessages": "Voir les messages précédents",
    "messageDeleted": "Message supprimé",
    "privateReply": "Réponse privée",
    "edited": "modifié",
    "offlineBanner": "Pas de connexion — les messages seront renvoyés automatiquement",
    "status": {
      "typing": "En train d'écrire...",
      "typingEllipsis": "En train d'écrire…",
      "online": "En ligne",
      "offline": "Hors ligne",
      "someoneTyping": "Quelqu'un écrit...",
      "someoneTypingEllipsis": "Quelqu'un écrit…",
      "memberCount_one": "{{count}} membre",
      "memberCount_other": "{{count}} membres"
    },
    "empty": {
      "title": "Aucun message",
      "subtitle": "Démarrez la discussion !"
    },
    "replyBar": {
      "publicPrefix": "Réponse publique à ",
      "privatePrefix": "Réponse privée à "
    },
    "editBar": {
      "label": "Modifier le message"
    },
    "input": {
      "placeholder": "Message...",
      "editPlaceholder": "Modifier le message..."
    },
    "media": {
      "document": "Document",
      "file": "Fichier",
      "voiceNote": "Note vocale"
    },
    "recording": {
      "inProgress": "En cours...",
      "inProgressEllipsis": "Enregistrement…"
    },
    "actions": {
      "replyPublicly": "Répondre en public",
      "replyPubliclySub": "Tout le groupe voit la réponse",
      "replyPrivately": "Répondre en privé",
      "replyPrivatelySub": "Visible uniquement par vous et le destinataire",
      "makePrivate": "Rendre privé",
      "makeVisible": "Rendre visible",
      "edit": "Modifier",
      "editSub": "Possible tant que non lu",
      "delete": "Supprimer",
      "cancel": "Annuler"
    },
    "errors": {
      "uploadUrlGeneration": "Erreur génération URL",
      "uploadFailed": "Erreur lors de l'upload",
      "uploadFailedHttp": "Échec de l'envoi (HTTP {{status}})",
      "uploadConfirmation": "Erreur confirmation",
      "transferFailed": "Erreur lors du transfert du fichier.",
      "microphonePermission": "Permission microphone requise. Vérifiez les autorisations du navigateur.",
      "permissionRequired": "Permission requise.",
      "cannotStartRecording": "Impossible de démarrer l'enregistrement.",
      "audioFileCreation": "Erreur lors de la création du fichier audio."
    }
  },
  "audioFeedModal": {
    "runNumber": "Run #{{number}}",
    "runLabel": "Run #{{number}} — {{title}}"
  },
  "tikTokVideoModal": {
    "runLabel": "Run #{{number}} — {{title}}"
  },
  "commentLikersModal": {
    "loading": "Chargement…",
    "likesCount_one": "like",
    "likesCount_other": "likes",
    "likedThisComment": "A aimé ce commentaire",
    "likePill": "Like",
    "empty": {
      "title": "Aucun like pour l'instant",
      "subtitle": "Sois le premier à réagir !"
    }
  },
  "limitNotification": {
    "titlePro": "Limite PRO atteinte",
    "titleDaily": "Limite quotidienne",
    "upgradeButton": "Passer PRO"
  },
  "legalDocumentScreen": {
    "defaultBadgeText": "Document légal officiel",
    "lastUpdated": "Dernière mise à jour : {{date}}",
    "sectionsLabel": "SECTIONS",
    "copyright": "© {{year}} Harmonia · Tous droits réservés",
    "intro": {
      "title": "Votre vie privée, notre priorité",
      "text": "Harmonia s'engage à protéger vos données avec la plus haute rigueur. Aucune donnée n'est vendue ou transmise à des tiers commerciaux."
    },
    "pills": {
      "zeroTracking": "Zéro tracking",
      "encrypted": "Chiffré",
      "gdpr": "RGPD",
      "internalAdsOnly": "Pub interne seul"
    },
    "contact": {
      "title": "Une question sur vos données ?"
    },
    "footer": {
      "privacy": "Confidentialité",
      "cookies": "Cookies",
      "terms": "CGU",
      "rules": "Règles"
    }
  },
  "shareButton": {
    "title": "Partager",
    "sharedOnHarmonia": "Partagé sur Harmonia ✓",
    "shareWithFriends": "Partager avec mes amis",
    "visibleInFriendsFeed": "Visible dans le feed de vos amis",
    "socialNetworks": "Réseaux sociaux",
    "more": "Plus",
    "cancel": "Annuler"
  },
  "submissionCard": {
    "runLabel": "Run #{{number}} — {{title}}",
    "vote": "Voter",
    "voted": "Voté 💪",
    "badges": {
      "arts": "🎨 Arts",
      "artisanat": "🪡 Artisanat"
    },
    "mediaBadges": {
      "audio": "Audio",
      "video": "Vidéo",
      "artisanat": "Artisanat"
    }
  },
  "publicShopScreen": {
    "loadingShop": "Chargement de la boutique…",
    "newBadge": "Nouveau",
    "products": "Produits",
    "noProducts": "Aucun produit publié pour l'instant.",
    "subscribe": "S'abonner",
    "retry": "Réessayer",
    "whatsappMessage": "Bonjour, je découvre votre boutique \"{{name}}\" sur Harmonia Market.",
    "errors": {
      "shopNotFound": "Cette boutique n'existe pas ou n'est plus disponible.",
      "cannotLoadShop": "Impossible de charger cette boutique.",
      "cannotReachServer": "Impossible de contacter le serveur."
    }
  },
  "publicProductScreen": {
    "loadingProduct": "Chargement du produit…",
    "newBadge": "Nouveau",
    "back": "Retour",
    "retry": "Réessayer",
    "defaultMetaTitle": "Produit",
    "descriptionTitle": "Description",
    "inStock_one": "En stock ({{count}})",
    "inStock_other": "En stock ({{count}})",
    "outOfStock": "Rupture de stock",
    "contactViaWhatsApp": "Contacter via WhatsApp",
    "buy": "Acheter",
    "learnMore": "En savoir plus",
    "call": "Appeler",
    "goToShop": "Aller en boutique",
    "whatsappMessage": "Bonjour, je suis intéressé(e) par \"{{name}}\" sur Harmonia Market.",
    "condition": {
      "new": "Neuf",
      "used": "Occasion",
      "refurbished": "Reconditionné"
    },
    "errors": {
      "productNotFound": "Ce produit n'existe pas ou n'est plus disponible.",
      "cannotLoadProduct": "Impossible de charger ce produit.",
      "cannotReachServer": "Impossible de contacter le serveur."
    }
  },
  "commentCaMarcheScreen": {
    "cta": "Créer mon compte gratuitement",
    "seo": {
      "title": "Comment ça marche ? Guide complet Harmonia World",
      "description": "Découvrez comment fonctionne Harmonia World : créez votre compte, participez à des concours de talents dans 6 disciplines, rejoignez une communauté créative, ou créez votre boutique en ligne avec votre propre site professionnel. Guide complet pas à pas.",
      "ogDescription": "Concours de talents, communauté créative, boutiques en ligne : le guide complet du fonctionnement d'Harmonia World."
    },
    "hero": {
      "titleLine1": "Comment fonctionne",
      "titleLine2": "Harmonia World ?",
      "sub": "Harmonia World est une plateforme sociale qui réunit trois univers en un seul endroit : des concours de talents ouverts à tous, une communauté créative internationale, et une marketplace permettant à chacun de créer sa propre boutique en ligne avec un site web professionnel. Ce guide explique en détail chaque fonctionnalité, étape par étape."
    },
    "presentation": {
      "chip": "PRÉSENTATION",
      "title": "Une plateforme, trois univers",
      "p1": "Harmonia World est accessible sur le web et sur mobile. Elle permet à chaque membre de créer un profil, publier du contenu, échanger via la messagerie et les groupes, participer à des concours de talents dans six disciplines, jouer à des jeux de culture générale et de stratégie, et — pour les commerçants, artisans et entrepreneurs — créer une boutique en ligne accompagnée d'un véritable site internet personnalisable.",
      "p2": "La plateforme repose sur une conviction simple : le talent n'a pas de frontières. Chaque discipline ouvre la porte à des concours réguliers, où les membres s'affrontent avec bienveillance, sont soutenus par le vote de la communauté, et peuvent voir leur talent récompensé par des trophées remis publiquement."
    },
    "gettingStarted": {
      "chip": "DÉMARRER",
      "title": "Créer son compte et se connecter",
      "step1": {
        "title": "Inscription",
        "desc": "Créez votre compte avec votre nom, prénom, adresse email et une date de naissance, ou inscrivez-vous directement via Google en un clic. L'inscription est ouverte à toute personne, dans le monde entier, sans restriction d'âge."
      },
      "step2": {
        "title": "Vérification de l'email",
        "desc": "Un email de confirmation est envoyé automatiquement. Il suffit de cliquer sur le lien reçu puis de revenir sur l'application pour activer définitivement le compte."
      },
      "step3": {
        "title": "Connexion",
        "desc": "Une fois le compte activé, la connexion se fait avec l'email et le mot de passe choisis. Il est possible de rester connecté pour éviter de ressaisir ses identifiants à chaque ouverture."
      },
      "step4": {
        "title": "Mot de passe oublié",
        "desc": "En cas d'oubli, un lien de réinitialisation est envoyé par email pour choisir un nouveau mot de passe en toute sécurité."
      }
    },
    "talentHub": {
      "chip": "CENTRE DES TALENTS",
      "title": "Six disciplines, des concours chaque semaine",
      "p1": "Le Centre des Talents propose des concours actifs répartis en six grandes disciplines. Chaque semaine, de nouveaux défis sont ouverts à tous les membres. Les participants soumettent leurs créations ou s'affrontent directement, puis la communauté vote pour désigner les meilleurs talents. Les concours menant à une étape finale physique se déroulent dans un pays choisi aléatoirement par Harmonia, avec un jury d'experts sélectionné pour garantir l'équité.",
      "p2": "Harmonia World ne propose aucun jeu de hasard. L'objectif exclusif des concours est de révéler et récompenser des talents réels, évalués par le vote de la communauté et, pour les finales, par des jurys experts."
    },
    "disciplines": {
      "strategie": {
        "label": "Jeux Stratégiques",
        "tagline": "Réflexion & tactique pure",
        "desc": "Awalé et Dames : affrontez vos adversaires dans des duels de stratégie intense."
      },
      "connaissance": {
        "label": "Connaissances",
        "tagline": "Testez votre savoir",
        "desc": "Vrai ou Faux : des duels intellectuels aussi palpitants qu'imprévisibles."
      },
      "arts": {
        "label": "Arts",
        "tagline": "Créativité & expression",
        "desc": "Photo, Dessin, Design : exposez vos créations et recevez la reconnaissance qu'elles méritent."
      },
      "performance": {
        "label": "Performance",
        "tagline": "Montez sur scène",
        "desc": "Comédie, Danse, Théâtre : incarnez, captivez, transcendez."
      },
      "musique": {
        "label": "Musique",
        "tagline": "Faites vibrer la scène",
        "desc": "Chant, Piano, Guitare : votre voix, vos instruments, votre empreinte dans le monde."
      },
      "artisanat": {
        "label": "Artisanat",
        "tagline": "Savoir-faire d'excellence",
        "desc": "Couture, Menuiserie, Coiffure, Soudure, Mécanique : des métiers nobles, une maîtrise rare."
      }
    },
    "community": {
      "chip": "COMMUNAUTÉ",
      "title": "Publier, échanger, se faire des amis",
      "p1": "Le fil d'actualité permet à chaque membre de publier du contenu (texte, et pour les membres PRO, photos et vidéos) avec un niveau de visibilité choisi : public, visible par les amis uniquement, par les amis d'amis, ou strictement privé. Les publications peuvent être aimées, commentées, partagées et sauvegardées.",
      "p2": "Harmonia propose également une messagerie privée et des groupes de discussion, ainsi qu'un système d'amis avec suggestions, recherche d'utilisateurs et gestion des demandes envoyées ou reçues."
    },
    "proSolution": {
      "chip": "SOLUTION PRO",
      "title": "Votre boutique, votre site, votre monde",
      "p1": "Les membres PRO peuvent créer une boutique directement depuis Harmonia. Chaque boutique devient un véritable site internet, personnalisable dans sa mise en page, sa présentation et son identité visuelle, accessible aussi bien depuis l'application que via un lien public fonctionnel sur le web — sans que les visiteurs aient besoin d'un compte pour consulter la boutique ou ses produits.",
      "step1": {
        "title": "Créer sa boutique",
        "desc": "Depuis le Market, les membres PRO accèdent aux réglages de leur boutique et la mettent en ligne en quelques étapes."
      },
      "step2": {
        "title": "Personnaliser son site",
        "desc": "Le design et de nombreux paramètres du site associé à la boutique peuvent être ajustés pour qu'il reflète l'identité du commerçant, de l'artisan ou de l'entrepreneur."
      },
      "step3": {
        "title": "Publier des produits",
        "desc": "Chaque produit ajouté dispose automatiquement de sa propre page et de son propre lien web, consultable et partageable indépendamment de la boutique."
      },
      "step4": {
        "title": "Être visible partout",
        "desc": "Le lien de la boutique et ceux de chaque produit peuvent être partagés sur n'importe quelle plateforme, permettant de vendre et d'échanger avec des clients dans le monde entier."
      }
    },
    "proStatus": {
      "chip": "STATUT PRO",
      "title": "Ce que débloque le statut PRO",
      "p1": "Le statut PRO permet de publier plus fréquemment (3 publications par jour contre 1 pour les membres standards), d'ajouter photos et vidéos aux publications, d'envoyer des médias et des notes vocales dans les messages, et surtout de créer une boutique en ligne avec son propre site public. Un badge distinctif rend le statut visible sur le profil."
    },
    "faq": {
      "chip": "QUESTIONS FRÉQUENTES",
      "title": "Questions fréquentes",
      "q1": {
        "question": "Harmonia World est-elle accessible partout dans le monde ?",
        "answer": "Oui. L'inscription est ouverte à toute personne dans le monde entier, sans restriction d'âge, et la plateforme est disponible sur le web comme sur mobile."
      },
      "q2": {
        "question": "Les concours sont-ils des jeux de hasard ?",
        "answer": "Non. Harmonia World ne propose aucun jeu de hasard. L'objectif exclusif des concours est de révéler et récompenser des talents réels grâce au vote de la communauté et, pour les finales, à des jurys experts."
      },
      "q3": {
        "question": "Faut-il un compte Harmonia pour consulter une boutique ?",
        "answer": "Non. Chaque boutique publiée dispose d'un lien public fonctionnel, consultable par n'importe quel visiteur sans création de compte."
      },
      "q4": {
        "question": "Quelle est la différence entre un compte standard et un compte PRO ?",
        "answer": "Le compte PRO permet de publier davantage, d'ajouter des médias enrichis aux publications et aux messages, et surtout de créer une boutique en ligne avec son propre site web public."
      }
    }
  }
}
